import { render, staticRenderFns } from "./NotifyTemplate.vue?vue&type=template&id=fc677562"
import script from "./NotifyTemplate.vue?vue&type=script&lang=js"
export * from "./NotifyTemplate.vue?vue&type=script&lang=js"
import style0 from "./NotifyTemplate.vue?vue&type=style&index=0&id=fc677562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports